const t = "modalTransitionEnter_PJbQr", i = "modalTransitionEnterActive_jU1C8", n = "modalTransitionExit_cCtoI", o = "modalTransitionExitActive_-hoRm", a = {
  modalTransitionEnter: t,
  modalTransitionEnterActive: i,
  modalTransitionExit: n,
  modalTransitionExitActive: o
};
export {
  a as default,
  t as modalTransitionEnter,
  i as modalTransitionEnterActive,
  n as modalTransitionExit,
  o as modalTransitionExitActive
};
//# sourceMappingURL=modal-transition.module.scss.js.map
